export default "__VITE_ASSET__hOj3dZc9__"